import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import Dots from "react-activity/dist/Dots";
import "react-activity/dist/library.css";

import AutoGrowTextarea from "../home/AutoGrowTextarea";

import i18n from "../../../i18n";

import ReactionsInner from './ReactionsInner';


const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');


const viewportWidth =  window.innerWidth;
const viewportHeight = window.innerHeight;

let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize14, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize14 = 14;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize14 = 13;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize14 = 12;
   titleFontSize13 = 11;
}



function convertDate(date, lang) {
  if (date === undefined || date === null)
  {
     date = new Date();
  }
  const now = new Date();
  const past = new Date(date);
  const diff = Math.floor((now - past) / 1000); // en secondes

  if (lang === 'fr')
  {

        const units = [
          { label: 'a', seconds: 31536000 },
          { label: 'm', seconds: 2592000 },
          { label: 'sem', seconds: 604800 },
          { label: 'j', seconds: 86400 },
          { label: 'h', seconds: 3600 },
          { label: 'min', seconds: 60 },
          { label: 's', seconds: 1 },
        ];

        for (let unit of units) {
          const value = Math.floor(diff / unit.seconds);
          if (value >= 1) {
            const plural = value > 1 ? '' : '';
            return `${value}${unit.label}${plural}`;
          }
        }

        return "à l'instant";

   }
   else
   {
         const units = [
           { label: 'y', seconds: 31536000 },
           { label: 'm', seconds: 2592000 },
           { label: 'w', seconds: 604800 },
           { label: 'd', seconds: 86400 },
           { label: 'h', seconds: 3600 },
           { label: 'min', seconds: 60 },
           { label: 's', seconds: 1 },
         ];

         for (let unit of units) {
           const value = Math.floor(diff / unit.seconds);
           if (value >= 1) {
             const plural = value > 1 ? '' : '';
             return `${value} ${unit.label}${plural}`;
           }
         }

         return "just now";
   }
}


class PopComments extends Component {
  constructor(props) {
    super(props);
    this.popupRef = createRef();




    let _user = null;
    if (props.sinUser !== null)
    {
       _user = JSON.parse(props.sinUser);
    }


    this.state = {
      body: '',
     user: _user,
     users: [],
     total_comments: this.props.selectedObject.total_comments || 0,
     comments: this.props.selectedObject.comments || [],
     status: 'init',
     processing: false,
     showInnerDiv: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);

    this.loadComments();

    /*
    if (this.state.total_comments < 196)
    {
       this.loadComments();
    }
    else
    {
       this.loadComments2();
     } */
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }


  loadComments() {

    var index = client.initIndex('Commentaire');

    index
    .search('*',
    {
      page: 0,
      filters: `searchable_object_id:${this.props.selectedObject.objectID}`,
      hitsPerPage: 200
    })
    .then(({ hits, nbPages, page, nbHits }) =>
      {
           //alert(nbHits)

            if (nbHits > 0)
            {

                 this.setState({
                   total_comments: nbHits,
                   comments: hits
                 });

            }



     });
  }

  loadComments2() {

    var index = client.initIndex('Story');

    index
    .search('*',
    {
      page: 0,
      filters: `searchable_id:${this.props.selectedObject.objectID}`,
      hitsPerPage: 1
    })
    .then(({ hits, nbPages, page, nbHits }) =>
      {
           //alert(nbHits)

            if (nbHits > 0)
            {

                 this.setState({
                   total_comments: hits[0].total_comments,
                   comments: hits[0].comments
                 });

            }



     });
  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.closePopup(); // Call the function to close the popup
    }
  }

  closePopup() {
    this.setState({
      showInnerDiv: false
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);

  }

  displayInnerDiv() {
    this.setState({
      showInnerDiv: true
    });
  }


  signinToComment() {
     //this.props.signinToComment();


     localStorage.setItem("storrypageAfter", `p/${this.props.selectedObject.public_id}?a=in&source=sp`);
     setTimeout(() => {
       window.location = `/signin?after=p/${this.props.selectedObject.public_id}?a=in&source=sp`;
     }, 200);

  }



  onChangeText = e => {
     this.setState({
       body: e.target.value
     })
  }


  sendComment() {

    const body = this.state.body;
    const id = 'id_' + Math.random().toString(36).substr(2, 9);
    this.setState({
      processing: true,
      tempID: id,
      body: ''
    });


    this.setState({
      processing: true
    });


    var ip = 'https://api1.debyoo.com/';

    var jwtToken = this.state.user.jwt_token;


    let hash = {
      auth_check: 'jwt',
      object_type: 'moment',
      id: this.props.selectedObject.objectID,
      ip: global.ip,
      country: global.country,
      continent: global.continent,
      region: '',
      city: '',
      typef: 'Text',
      body: body,
    };

    //alert(JSON.stringify(hash));


    fetch(ip+'post_story_comment_api', {
           method: 'POST',
           headers: {
             'Accept': 'application/json',
             'Authorization': jwtToken,
             'Content-Type': 'application/json'
           },
           credentials: 'include',
           body: JSON.stringify(hash)
        })
      .then((response) => response.json())
      .then((responseData) => {

                  client.clearCache();

                  let newComment = {
                    objectID: responseData.id,
                    user_id: this.state.user.uid,
                    user_name: this.state.user.name,
                    user_sigle: responseData.user_sigle,
                    user_screenname: this.state.user.screenname,
                    user_picture: this.state.user.thumbnail,
                    body: body,
                    typef: 'Text',
                    created_at: new Date(),
                    user_verification: responseData.uv,
                    created_at: new Date(),
                    replies: [],
                    reactions: []
                  };



                  const comments = this.state.comments;

                  comments.unshift(newComment);

                  this.setState({
                    total_comments: (Number(this.state.total_comments)+1),
                    comments: comments,
                    processing: false
                  });

        })
        .catch(function(error) {

        }.bind(this));


  }


  deleteComment(comment) {
     //alert(comment.objectID)
     const comments = [...this.state.comments];

     const updatedArray = comments.filter(obj => obj.objectID !== comment.objectID);

     this.setState({
       comments: updatedArray,
       total_comments: (Number(this.state.total_comments)-1),
     });


     var ip = 'https://api1.debyoo.com/';

     var jwtToken = this.state.user.jwt_token;


     let hash = {
       auth_check: 'jwt',
       id: comment.objectID
     };

     //alert(JSON.stringify(hash));


     fetch(ip+'delete_story_comment_api', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Authorization': jwtToken,
              'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(hash)
         })
       .then((response) => response.json())
       .then((responseData) => {


         })
         .catch(function(error) {

         }.bind(this));

  }




  renderUser = ({index, item}) => {
    return (
      <div style={{position: 'relative', width: '100%', height: '80px',}}>
          <View style={{width: '100%', height: '80px', flexDirection: 'row'}}>

                 <View style={{width: 52, height: 60, justifyContent: 'center'}}>
                    <View style={{width: 50, height: 50, borderRadius: 25, backgroundColor: '#28434d'}}><Image source={{uri: item.picture}} style={{width: 50, height: 50, borderRadius: 25, borderWidth: 1, borderColor: '#ccc'}}/></View>
                 </View>
                 <View style={{marginLeft: 10, width: ((840/2)-72)+'px', height: 60, justifyContent: 'center'}}>
                      <Text numberOfLines={2} style={{fontSize: titleFontSize17+'px', color:'#111', fontWeight: '800'}}>{item.name}</Text>
                 </View>

          </View>
      </div>
    )
  }





  render() {
    return (
      <div style={{position: 'fixed', zIndex: 99, width: '100%', height: '100%', top: 0, left: 0, bottom: 0, display: 'flex',
                               alignItems: 'center',backgroundColor: 'rgba(0,0,0,0.1)'}}>

            {isMobileOnly &&
              <div className="scroll-area"
                     style={{
                       width: '100%',
                       maxHeight: "100vh",
                       overflowY: "hidden",
                       position: "relative",
                       zIndex: 0,
                     }}
                   >

               <div style={{width: '100%', minHeight: viewportHeight+'px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', overflow: 'hidden'}}>

                    <AnimatePresence>

                        {this.state.showInnerDiv && (

                            <motion.div ref={this.popupRef}
                                     initial={{ x: "100%", opacity: 0 }}
                                    animate={{ x: "0%", opacity: 1 }}
                                    exit={{ x: "100%", opacity: 0 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                    style={{position: 'relative', width: '100%',
                                          height: viewportHeight*1.1+'px', overflow: 'auto',
                                          marginTop: '0px', marginBottom: '40px',
                                         backgroundColor: 'white',
                                         boxShadow: "-2px 0 8px rgba(0,0,0,0.1)"}}>


                                         <div style={{position: 'fixed', zIndex: 3, top: 0, width: '100%', height: '50px', backgroundColor: '#fff', borderBottom: '1px solid #ccc'}}>
                                             <div style={{width: '94%', height: '50px', margin: 'auto'}}>
                                                 <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                    <div>
                                                        <View style={{height: '50px', justifyContent: 'center'}}>
                                                           {this.state.total_comments === 0 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{i18n.t('Comments')}</Text>}
                                                           {this.state.total_comments === 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.total_comments} {i18n.t('Comment')}</Text>}
                                                          {this.state.total_comments > 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.total_comments} {i18n.t('Comments')}</Text>}
                                                        </View>
                                                    </div>




                                                      <div onClick={this.closePopup.bind(this)}>
                                                          <View style={{height: '50px', justifyContent: 'center'}}>
                                                             <Image source={{uri: '/img/cancel_icon_grey.png'}} style={{width: '30px', height: '30px'}}/>
                                                          </View>
                                                      </div>


                                                 </div>
                                             </div>
                                         </div>



                                         <div style={{width: '100%'}}>


                                                 {!this.props.selectedObject.comments_are_on &&
                                                    <div style={{width: '100%', marginTop: '92px' }}>
                                                       <div style={{width: '90%', margin: 'auto', textAlign: 'center'}}>
                                                           <div style={{marginTop: '160px', color: '#333', fontSize: titleFontSize20+'px'}}>{i18n.t('Comments_are_turned_off')}</div>
                                                       </div>
                                                   </div>
                                                 }

                                                 {this.props.selectedObject.comments_are_on &&
                                                     <div style={{width: '100%', marginTop: '92px' }}>

                                                             {this.state.comments.map((comment, index) => (
                                                               <div key={comment.objectID+'_'+index} style={{width: '100%', paddingTop: '10px', paddingBottom: '10px'}}>
                                                                   <View style={{width: '100%', display: 'flex', flexDirection: 'row'}}>

                                                                          <View style={{marginLeft: 10, width: 42, height: 60, justifyContent: 'flex-start'}}>
                                                                             <View style={{width: 40, height: 40, borderRadius: 20, backgroundColor: '#28434d'}}>
                                                                                <Image source={{uri: comment.user_picture.replace('/pictures/normal/missing.png','/img/default_avatar_normal.png')}}
                                                                                       style={{width: 40, height: 40, borderRadius: 20, borderWidth: 1, borderColor: '#ccc'}}/>
                                                                             </View>
                                                                          </View>
                                                                          <View style={{marginLeft: 15, width: (viewportWidth-30-60)+'px', justifyContent: 'flex-start'}}>
                                                                               <Text style={{fontSize: '16px', color:'#333', lineHeight: '19px'}}>
                                                                                  {comment.user_sigle !== null && comment.user_sigle !== undefined && comment.user_sigle !== "" && <Text style={{fontSize: '16px', color:'#111', fontWeight: '800'}}>{comment.user_name}</Text>}{(comment.user_sigle === null || comment.user_sigle === undefined || comment.user_sigle === "") && <Text style={{fontSize: '16px', color:'#111', fontWeight: '800'}}>{comment.user_name}</Text>} {comment.user_verification === 'Organization' && <Image source={{uri: '/img/verified_organization.png'}} style={{width: '18px', height: '18px'}}/>}{comment.user_verification === 'Brand' && <Image source={{uri: '/img/verified_brand.png'}} style={{width: '18px', height: '18px'}}/>}{comment.user_verification === 'Personal' && <Image source={{uri: '/img/verified_profile.png'}} style={{width: '18px', height: '18px'}}/>}{'  '}{comment.body}
                                                                               </Text>

                                                                               <View style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
                                                                                   <View><Text style={{fontSize: '13px', color:'#777'}}>{convertDate(comment.created_at, i18n.language)}</Text></View>
                                                                                   <View style={{width: '20px'}}/>
                                                                                   {comment.user_id === this.state.user.uid &&
                                                                                      <View><Text style={{fontSize: '13px', color:'#333', fontWeight: 'bold'}}><Text onPress={this.deleteComment.bind(this, comment)} style={{fontSize: '13px', color:'#333', fontWeight: 'bold'}}>{i18n.t('Delete')}</Text></Text></View>
                                                                                   }
                                                                               </View>
                                                                          </View>

                                                                   </View>
                                                               </div>
                                                             ))}

                                                             <div style={{clear: 'both', height: '100px'}}/>

                                                     </div>
                                                   }

                                          </div>





                                          <div style={{position: 'fixed', bottom: 0, left: 0, zIndex: 3, width: '100%', minHeight: '60px', backgroundColor: '#fff'}}>
                                             {this.state.user === null &&
                                               <div style={{width: '100%', borderTop: '1px solid #ccc'}}>
                                                 <div style={{width: '94%', margin: 'auto', display: 'flex', flexDirection: 'row'}}>
                                                     <div>
                                                        <View style={{height: '60px', justifyContent: 'center'}}>
                                                           <Text onPress={this.signinToComment.bind(this)} style={{color: '#0b49ff', fontSize: titleFontSize18+'px'}}>{i18n.t('Signin_you')}</Text>
                                                         </View>
                                                     </div>
                                                     <div style={{marginLeft: '5px'}}>
                                                        <View style={{height: '60px', justifyContent: 'center'}}>
                                                           <Text style={{color: '#111', fontSize: titleFontSize18+'px'}}>{i18n.t('to_comment')}</Text>
                                                         </View>
                                                     </div>
                                                 </div>
                                               </div>
                                             }
                                             {this.state.user !== null &&
                                               <div style={{width: '100%', height: 'auto',  marginBottom: '5px',
                                                            borderTop: '1px solid #ccc', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#fff'}}>
                                                 <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                     <div style={{width: (viewportWidth-95)+'px', marginLeft: '15px', paddingTop: '5px', backgroundColor: '#fff'}}>
                                                        <AutoGrowTextarea value={this.state.body} onChange={this.onChangeText} width={viewportWidth-110} fontSize={titleFontSize17} placeholder={i18n.t('Add_a_comment')} />
                                                     </div>
                                                     {this.state.body.trim() === '' && !this.state.processing &&
                                                       <div style={{width: '60px', opacity: 0.3, marginTop: 'auto', backgroundColor: '#fff'}}>
                                                           <View style={{width: '60px', height: '60px', alignItems: 'center', justifyContent: 'center'}}>
                                                              <Image source={{uri: '/img/comment_send_icon.png'}} style={{width: '50px', height: '50px'}}/>
                                                            </View>
                                                       </div>
                                                     }
                                                     {this.state.body.trim() !== '' && !this.state.processing &&
                                                       <div onClick={this.sendComment.bind(this)} style={{width: '60px', cursor: 'pointer', marginTop: 'auto', backgroundColor: '#fff'}}>
                                                           <View style={{width: '60px', height: '60px', alignItems: 'center', justifyContent: 'center'}}>
                                                              <Image source={{uri: '/img/comment_send_icon.png'}} style={{width: '50px', height: '50px'}}/>
                                                            </View>
                                                       </div>
                                                     }

                                                     {this.state.processing &&
                                                       <div onClick={this.sendComment.bind(this)} style={{width: '60px', cursor: 'pointer', marginTop: 'auto', backgroundColor: '#fff'}}>
                                                           <View style={{width: '60px', height: '60px', alignItems: 'center', justifyContent: 'center'}}>
                                                              <View style={{width: '50px', height: '50px', backgroundColor: '#0b49ff', borderRadius: '25px', alignItems: 'center', justifyContent: 'center'}}>
                                                                 <Dots color={'#fff'} size={12}/>
                                                              </View>
                                                            </View>
                                                       </div>
                                                     }
                                                 </div>
                                               </div>
                                             }
                                          </div>




                             </motion.div>
                         )}

                     </AnimatePresence>

                  </div>

              </div>
            }




            {!isMobileOnly &&
              <div className="scroll-area"
                     style={{
                       width: '100%',
                       maxHeight: "100vh",
                       overflowY: "hidden",
                       position: "relative",
                       zIndex: 0,
                     }}
                   >

               <div style={{width: '100%', minHeight: viewportHeight+'px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', overflow: 'hidden'}}>

                    <AnimatePresence>

                        {this.state.showInnerDiv && (

                            <motion.div ref={this.popupRef}
                                     initial={{ x: "100%", opacity: 0 }}
                                    animate={{ x: "0%", opacity: 1 }}
                                    exit={{ x: "100%", opacity: 0 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                   style={{position: 'relative', width: '540px', display: 'flex', alignSelf: 'flex-end',
                                         height: isTablet ? (viewportHeight+40)+'px':viewportHeight+'px', overflow: 'auto',
                                         marginTop: '0px', marginBottom: '0px',
                                         backgroundColor: 'white',
                                         boxShadow: "-2px 0 8px rgba(0,0,0,0.1)"}}>



                                         <div style={{position: 'fixed', zIndex: 99, top: 0, right: 0, width: '540px', height: '50px', borderBottom: '1px solid #ccc', backgroundColor: '#fff'}}>
                                             <div style={{width: '520px', height: '50px', margin: 'auto'}}>
                                                 <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                    <div>
                                                        <View style={{height: '50px', justifyContent: 'center'}}>
                                                             {this.state.total_comments === 0 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{i18n.t('Comments')}</Text>}
                                                             {this.state.total_comments === 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.total_comments} {i18n.t('Comment')}</Text>}
                                                             {this.state.total_comments > 1 && <Text style={{color: '#333', fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.state.total_comments} {i18n.t('Comments')}</Text>}
                                                        </View>
                                                    </div>




                                                      <div onClick={this.closePopup.bind(this)}>
                                                          <View style={{height: '50px', justifyContent: 'center'}}>
                                                             <Image source={{uri: '/img/cancel_icon_grey.png'}} style={{width: '30px', height: '30px'}}/>
                                                          </View>
                                                      </div>


                                                 </div>
                                             </div>
                                         </div>


                                         <div style={{width: '100%'}}>


                                                 {!this.props.selectedObject.comments_are_on &&
                                                    <div style={{width: '100%', marginTop: '68px' }}>
                                                       <div style={{width: '90%', margin: 'auto', textAlign: 'center'}}>
                                                           <div style={{marginTop: '200px', color: '#333', fontSize: titleFontSize20+'px'}}>{i18n.t('Comments_are_turned_off')}</div>
                                                       </div>
                                                   </div>
                                                 }

                                                 {this.props.selectedObject.comments_are_on &&
                                                   <div style={{width: '540px', marginTop: '68px' }}>

                                                           {this.state.comments.map((comment, index) => (
                                                             <div key={comment.objectID+'_'+index} style={{width: '540px', paddingTop: '10px', paddingBottom: '10px'}}>
                                                                 <View style={{width: this.props.width+'px', display: 'flex', flexDirection: 'row'}}>

                                                                        <View style={{marginLeft: 10, width: 42, height: 60, justifyContent: 'flex-start'}}>
                                                                           <View style={{width: 40, height: 40, borderRadius: 20, backgroundColor: '#28434d'}}>
                                                                              <Image source={{uri: comment.user_picture.replace('/pictures/normal/missing.png','/img/default_avatar_normal.png')}}
                                                                                     style={{width: 40, height: 40, borderRadius: 20, borderWidth: 1, borderColor: '#ccc'}}/>
                                                                           </View>
                                                                        </View>
                                                                        <View style={{marginLeft: 15, width: (540-30-60)+'px', justifyContent: 'flex-start'}}>
                                                                             <Text style={{fontSize: '16px', color:'#333', lineHeight: '19px'}}>
                                                                                <Text style={{fontSize: '16px', color:'#111', fontWeight: '800'}}>{comment.user_name}</Text> {comment.user_verification === 'Organization' && <Image source={{uri: '/img/verified_organization.png'}} style={{width: '18px', height: '18px'}}/>}{comment.user_verification === 'Brand' && <Image source={{uri: '/img/verified_brand.png'}} style={{width: '18px', height: '18px'}}/>}{comment.user_verification === 'Personal' && <Image source={{uri: '/img/verified_profile.png'}} style={{width: '18px', height: '18px'}}/>}{'  '}{comment.body}
                                                                             </Text>

                                                                             <View style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
                                                                                 <View><Text style={{fontSize: '13px', color:'#777'}}>{convertDate(comment.created_at, i18n.language)}</Text></View>
                                                                                 <View style={{width: '20px'}}/>
                                                                                 {comment.user_id === this.state.user.uid &&
                                                                                    <View><Text style={{fontSize: '13px', color:'#333', fontWeight: 'bold'}}><Text onPress={this.deleteComment.bind(this, comment)} style={{fontSize: '13px', color:'#333', fontWeight: 'bold'}}>{i18n.t('Delete')}</Text></Text></View>
                                                                                 }
                                                                             </View>
                                                                        </View>

                                                                 </View>
                                                             </div>
                                                           ))}

                                                           <div style={{clear: 'both', height: '100px'}}/>

                                                   </div>
                                                 }

                                         </div>





                                         <div style={{position: 'fixed', bottom: 0, right: 0, width: '540px', zIndex: 3, minHeight: '60px', backgroundColor: '#fff'}}>
                                            {this.state.user === null &&
                                              <div style={{width: '100%', borderTop: '1px solid #ccc'}}>
                                                <div style={{width: '94%', margin: 'auto', display: 'flex', flexDirection: 'row'}}>
                                                    <div>
                                                       <View style={{height: '60px', justifyContent: 'center'}}>
                                                          <Text onPress={this.signinToComment.bind(this)} style={{color: '#0b49ff', fontSize: titleFontSize18+'px'}}>{i18n.t('Signin_you')}</Text>
                                                        </View>
                                                    </div>
                                                    <div style={{marginLeft: '5px'}}>
                                                       <View style={{height: '60px', justifyContent: 'center'}}>
                                                          <Text style={{color: '#111', fontSize: titleFontSize18+'px'}}>{i18n.t('to_comment')}</Text>
                                                        </View>
                                                    </div>
                                                </div>
                                              </div>
                                            }
                                            {this.state.user !== null &&
                                              <div style={{width: '100%', height: 'auto',  marginBottom: '5px',
                                                           borderTop: '1px solid #ccc', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#fff'}}>
                                                <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                    <div style={{width: (540-95)+'px', marginLeft: '15px', paddingTop: '5px', backgroundColor: '#fff'}}>
                                                       <AutoGrowTextarea value={this.state.body} onChange={this.onChangeText} width={540-110} fontSize={titleFontSize17} placeholder={i18n.t('Add_a_comment')} />
                                                    </div>
                                                    {this.state.body.trim() === '' && !this.state.processing &&
                                                      <div style={{width: '60px', opacity: 0.3, marginTop: 'auto', backgroundColor: '#fff'}}>
                                                          <View style={{width: '60px', height: '60px', alignItems: 'center', justifyContent: 'center'}}>
                                                             <Image source={{uri: '/img/comment_send_icon.png'}} style={{width: '50px', height: '50px'}}/>
                                                           </View>
                                                      </div>
                                                    }
                                                    {this.state.body.trim() !== '' && !this.state.processing &&
                                                      <div onClick={this.sendComment.bind(this)} style={{width: '60px', cursor: 'pointer', marginTop: 'auto', backgroundColor: '#fff'}}>
                                                          <View style={{width: '60px', height: '60px', alignItems: 'center', justifyContent: 'center'}}>
                                                             <Image source={{uri: '/img/comment_send_icon.png'}} style={{width: '50px', height: '50px'}}/>
                                                           </View>
                                                      </div>
                                                    }

                                                    {this.state.processing &&
                                                      <div onClick={this.sendComment.bind(this)} style={{width: '60px', cursor: 'pointer', marginTop: 'auto', backgroundColor: '#fff'}}>
                                                          <View style={{width: '60px', height: '60px', alignItems: 'center', justifyContent: 'center'}}>
                                                             <View style={{width: '50px', height: '50px', backgroundColor: '#0b49ff', borderRadius: '25px', alignItems: 'center', justifyContent: 'center'}}>
                                                                <Dots color={'#fff'} size={12}/>
                                                             </View>
                                                           </View>
                                                      </div>
                                                    }
                                                </div>
                                              </div>
                                            }
                                         </div>



                             </motion.div>
                         )}

                     </AnimatePresence>

                  </div>

              </div>
            }

       </div>
    );
  }
}

export default PopComments;
